import { default as React, FunctionComponent } from 'react';
import { ButtonProps, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { ComponentsProps } from '@material-ui/core/styles/props';
import Translation from '../../translation/Translation';

export type ICalculateWeeklyButtonThemableProps = ComponentsProps['MuiButton'];

const CalculateWeeklyButton: FunctionComponent<ButtonProps> = props => {
  return (
    <Button variant={'outlined'} color={'primary'} {...props}>
      <Translation id={'spc.common.button.calculateWeekly'} />
    </Button>
  );
};

export default withStyles({}, { name: 'SPC_CalculateWeeklyButton' })(CalculateWeeklyButton);
